import * as React from "react";
import { withStyles, WithStyles, Theme, createStyles, StyleRulesCallback } from "../mui/styles";
import classNames from 'classnames';
import { TableCell } from "../widget";
import { BodyColumn, DataGridLines, DataGridPadding } from "./Types";

export interface DataGridBodyCellProps<T> extends BodyColumn<T> {
    row: T;
    gridLines?: DataGridLines;
    firstCol: boolean;
    lastRow: boolean;
    padding?: DataGridPadding;

    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

declare type Props<T> = DataGridBodyCellProps<T> & WithStyles<typeof styles>;

class DataGridBodyCell<T> extends React.PureComponent<Props<T>>{

    render() {

        const { classes, content, row, gridLines, firstCol, lastRow, padding, onClick } = this.props;

        const className = classNames({
            [classes.root]: true,
            [classes.horizontalLines]: lastRow || gridLines === 'horizontal' || gridLines === 'both',
            [classes.verticalLines]: firstCol === false && (gridLines === 'vertical' || gridLines === 'both'),

            [classes.paddingNone]: padding === 'none',
            [classes.paddingDense]: padding === 'dense',
            [classes.paddingExtraDense]: padding === 'extra-dense',

        })


        return <TableCell className={className} variant="body" onClick={onClick}>
            {content(row)}
        </TableCell>;
    }
}



const styles = ((theme: Theme) => {

    return createStyles({

        root: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflowX: 'hidden',
            border: 'none',
            paddingLeft: 8,
            paddingRight: 8,
        },

        horizontalLines: {
            borderBottom: '1px solid ' + theme.palette.divider,
        },

        verticalLines: {
            borderLeft: '1px solid ' + theme.palette.divider,
        },

        paddingNone: {
            padding: 0,
        },

        paddingExtraDense: {
            padding: 4,
        },

        paddingDense: {
            padding: 8,
        },

    })
}) as StyleRulesCallback;

export default withStyles(styles, { name: 'DataGridBodyCell' })(DataGridBodyCell);
